import { useEffect, useState } from 'react'
import { fetchShips } from '../backend/ships'
import Ship from '../types/Ship'

export default function useShips() {
  const [ships, setShips] = useState<Array<Ship>>([])
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    ;(async () => {
      try {
        if (ships.length === 0 && !hasError) {
          const ships = await fetchShips()
          if (ships.length === 0) {
            setHasError(true)
          }
          setShips(ships.filter((value: Ship | null) => value !== null))
        }
      } catch {
        setHasError(true)
        return
      }
    })()
  }, [ships, hasError])

  return { ships, hasError }
}
